import { render } from "./MagazineManageView.vue?vue&type=template&id=cdd107de&scoped=true"
import script from "./MagazineManageView.vue?vue&type=script&lang=js"
export * from "./MagazineManageView.vue?vue&type=script&lang=js"

import "./MagazineManageView.vue?vue&type=style&index=0&id=cdd107de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdd107de"]])

export default __exports__